export default __webpack_public_path__ + "static/media/luchopquy.f915a419.png";